import { utils } from "../../utils";
import { DiscountModel } from "../../models";
import { BillMode } from "./BillClientModal.types";
import { isBefore, isSameDay } from 'date-fns';
import { normalizeEffectiveDate } from "./BillingDate/BillingDate.utils";
export let BillClientDisabledReason = /*#__PURE__*/function (BillClientDisabledReason) {
  BillClientDisabledReason["oneTimeManualAlreadyInList"] = "This one-time service has already been included in this invoice";
  BillClientDisabledReason["billedMaxCharges"] = "This service was already billed the maximum number of times";
  BillClientDisabledReason["issuingInvoice"] = "This one-time service has already been added to a future invoice";
  BillClientDisabledReason["none"] = "";
  return BillClientDisabledReason;
}({});
export function discountToDTO(discount) {
  if (discount.amount) {
    const amountAsNumber = +discount.amount;
    return amountAsNumber ? {
      type: discount.type,
      temp_amount: utils.dollarsToCents(amountAsNumber)
    } : undefined;
  } else {
    return undefined;
  }
}
export function getTotal(quantity, rate, selectedServiceOption, discount) {
  if (!selectedServiceOption || !rate || !quantity) return;
  return utils.calculateFinalPrice(+rate, DiscountModel.make(discount.type, +discount.amount), +quantity);
}
export function getBiCode(mode, issueDate, now) {
  switch (mode) {
    case BillMode.Upcoming:
      return 18400;
    case BillMode.FutureDate:
      return 18401;
    case BillMode.Now:
      return isSameDay(issueDate, now) ? 18403 : 18402;
  }
}
export function getIssueDateBeforeRelationshipEffectiveDateWarning(relationshipEffectiveDate, issueDate) {
  const effectiveDate = normalizeEffectiveDate(relationshipEffectiveDate);
  if (effectiveDate && isBefore(issueDate, effectiveDate)) {
    return {
      text: "As the issue date precedes the agreement's effective date, your client will need to manually approve the payment."
    };
  }
  return null;
}